import React, { useEffect, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { useShortCut } from '../shared/hooks/useShortCut';
import { useTextViewStore } from '../shared/store/TextViewStore';
import PageAboutText from '../component/text/PageAboutText';
import TextMetaStation from '../component/text/TextMetaStation';
import TextColumnInfo from '../component/text/TextColumnInfo';
import TextColumnInfoMobile from '../component/text/mobile/TextColumnInfoMobile';
import TextList from '../component/text/TextList';
import TextListFixed from '../component/text/fixed/TextListFixed';
import TextListMobile from '../component/text/mobile/TextListMobile';
import MobileConvertWrapper from '../shared/component/MobileConvertWrapper';
import { usePageOwnerIdentityStore } from '../shared/store/pageOwnerIdentityStore';
import { useParams } from 'react-router-dom';
import { usePageStore } from '../shared/store/pageStore';
import { useNavLayout } from '../shared/hooks/useNavLayout';
import { NavLayout } from '../shared/enum/EnumRepository';
import IndexTextViewerFixed from '../component/text/fixed/IndexTextViewerFixed';
import TextViewerShellFixed from '../component/text/fixed/TextViewerShellFixed';
import MultiTextViewerFixed from '../component/text/fixed/MultiTextViewerFixed';
import TextViewerFixed from '../component/text/fixed/TextViewerFixed';
import { useTextIndexing } from '../shared/hooks/useTextIndexing';
import { useTextTagStore } from '../shared/store/textTagStore';
import { useEditMode } from '../shared/hooks/useEditMode';

const Texts: React.FC = () => {
  const { handleCmdE } = useShortCut();
  const navLayout = useNavLayout();
  const clearActiveText = useTextViewStore((s) => s.clearActiveText);
  const clearSelectedTags = useTextTagStore((s) => s.clearSelectedTags);
  const resetPage = usePageStore((s) => s.resetPage);
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const { HANDLE: raw } = useParams<{ HANDLE?: string }>();

  const hasMultiSelected = useTextViewStore((s) => s.multiSelectedText.length > 0);
  const setIsLargeBody = useTextViewStore((s) => s.setIsLargeBody);
  const { isIndexingMode } = useTextIndexing();
  const { isEditMode } = useEditMode();

  useEffect(() => {
    if (isEditMode) {
      setIsLargeBody(false);
    }
  }, [isEditMode, setIsLargeBody]);


  // 목록 stale은 canShow로 억제. 선택/페이지 메타만 아카이브 전환 시 리셋.
  useLayoutEffect(() => {
    clearActiveText();
    clearSelectedTags();
    resetPage();
  }, [raw, pageOwner?.aui]);

  return (
    <TextContainer
      $navLayout={navLayout}
      onKeyDown={(e) => handleCmdE(e)}
      tabIndex={-1}
    >
      {navLayout === NavLayout.FIXED ? (
        <>
          <TextSpace />
          <TextViewerShellFixed>
            {isIndexingMode ? (
              <IndexTextViewerFixed />
            ) : hasMultiSelected ? (
              <MultiTextViewerFixed />
            ) : (
              <TextViewerFixed />
            )}
          </TextViewerShellFixed>
          <TextListFixed />
        </>
      ) : (
        <>
          <TextMetaStation />
          <MobileConvertWrapper
            onlyMobileChildren={<TextColumnInfoMobile />}
            onlyNotMobileChildren={<TextColumnInfo />}
          />
          <MobileConvertWrapper
            onlyMobileChildren={<TextListMobile />}
            onlyNotMobileChildren={<TextList />}
          />
          <PageAboutText />
        </>
      )}
    </TextContainer>
  );
}

export default Texts;

const TextSpace = styled.div`
  flex: 1;
`;

const TextContainer = styled.main<{ $navLayout: NavLayout }>`
  display: flex;
  overflow: hidden;

  ${({ $navLayout }) =>
    $navLayout === NavLayout.FIXED
      ? `
    flex-direction: row;
    width: 100%;
    height: 100%;
    padding: 0 clamp(20px, 2vw, 30px) 0 clamp(12px, 1.2vw, 20px);
  `
      : `
    flex-direction: column;
    width: 93%;
    height: 100vh;
    margin-bottom: 3vh;
  `}
`;
